import { FC } from "react";
import OverViewInfo from "./OverViewInfo";
import MobileScreensImages from "./MobileScreensImages";

interface OverViewProps {}

const OverView: FC<OverViewProps> = ({}) => {
  return (
    <div className="py-12 px-8 bg-[#EEF0FF] rounded flex flex-col md:flex-row justify-start gap-10  ">
      <div className="col-span-2 md:col-span-1 order-2 md:order-1  ">
        <OverViewInfo />
      </div>
      <div className="col-span-2 md:col-span-1 order-1 md:order-2">
        <MobileScreensImages />
      </div>
    </div>
  );
};

export default OverView;
